
__webpack_require__.initializeExposesData = {
  moduleMap: {
  "./core": () => {
return Promise.all(/*  | __federation_expose_core */ [__webpack_require__.e("242"), __webpack_require__.e("264"), __webpack_require__.e("375"), __webpack_require__.e("538"), __webpack_require__.e("261")]).then(() => (() => (__webpack_require__(40420))));
},
"./LinkedRecordBase": () => {
return Promise.all(/*  | __federation_expose_LinkedRecordBase */ [__webpack_require__.e("242"), __webpack_require__.e("375"), __webpack_require__.e("679")]).then(() => (() => (__webpack_require__(60240))));
},
"./TasksView": () => {
return Promise.all(/*  | __federation_expose_TasksView */ [__webpack_require__.e("242"), __webpack_require__.e("264"), __webpack_require__.e("735")]).then(() => (() => (__webpack_require__(56082))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };